import type { Locale } from "@/lib/i18n";

/**
 * Taal in de URL: Nederlands staat op de kale paden (/categorie/glasartikelen), Engels onder een
 * /en-prefix (/en/categorie/glasartikelen).
 *
 * Waarom via de URL en niet (alleen) via een voorkeur in de browser: een taal die alleen in
 * localStorage bestaat, bestaat niet voor Google. Zonder eigen URL is er niets te indexeren, en
 * zag een Engelse bezoeker uit de zoekresultaten sowieso eerst de Nederlandse pagina.
 *
 * De router krijgt `/en` als basename (main.tsx), waardoor ALLE bestaande routes en <Link>s
 * ongewijzigd meeliften — geen dubbele routetabel, en Nederlandse paden blijven exact zoals ze
 * waren. Deze module is de enige plek die van dat prefix af weet.
 */
export const EN_PREFIX = "/en";

/** Taal die bij dit pad hoort. `/en` of `/en/...` → Engels; al het andere → Nederlands. */
export function localeFromPath(pathname: string): Locale {
  return pathname === EN_PREFIX || pathname.startsWith(`${EN_PREFIX}/`) ? "en" : "nl";
}

/** Router-basename voor dit pad: "/en" op de Engelse site, anders "/". */
export function basenameFromPath(pathname: string): string {
  return localeFromPath(pathname) === "en" ? EN_PREFIX : "/";
}

/** Het pad ZONDER taalprefix (dus zoals de routetabel het kent). */
export function stripLocale(pathname: string): string {
  if (!pathname.startsWith(EN_PREFIX)) return pathname;
  const rest = pathname.slice(EN_PREFIX.length);
  return rest === "" ? "/" : rest;
}

/** Hetzelfde pad in de gevraagde taal — voor de taalknop en de hreflang-verwijzingen. */
export function pathForLocale(pathname: string, locale: Locale): string {
  const kaal = stripLocale(pathname);
  if (locale === "nl") return kaal;
  return kaal === "/" ? EN_PREFIX : `${EN_PREFIX}${kaal}`;
}
